/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/26/20
 * Time: 2:43 PM
 */
import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";

import TxtLbl from "../../../../../components/Input/Input/TxtLbl";
import Lbl from "../../../../../components/Label/Lbl";
import {Button as SementicBtn, Checkbox, Form, Segment} from "semantic-ui-react";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {DatePicker} from "antd";
import moment from "moment";
import * as validator from "../../../../../util/Validator";
import * as common from "../../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import * as keys from "../../../../../const/key/Key";
import axiosTags from "../../../../../axios/axios_tag";
import apiConfig from "../../../../../axios/axios_api_services";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current < moment().startOf("day");
}

class App extends Component {
  state = {
    isLoad: false, start_date: "", end_date: "", corporateCode: "100", allowExternalReception: false, isStatus: true
  };

  handleChange = name => event => {
    let value = event.target.value;
    if (name === "contactNo" || name === "adminMobile" || name === "otp") {
      let isValid = validator.isOnlyNumbersValdator(value);
      if (!isValid && value !== "") {
        return;
      }
    }
    this.setState({
      [name]: value
    });
  };
  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      this.setState({
        start_date: start,
        end_date: end,
      })
    }
  };
  getData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.TEMP_CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {

        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  approveHandler = () => {
    let {start_date, end_date, corporateCode} = this.state;
    // corporateCode.trim() === "" ? common.notifyMessage("Please enter corporate code") :
      start_date === "" ? common.notifyMessage("Please select contract date range") :
        end_date === "" ? common.notifyMessage("Please select contract date range") :
          swal({
            title: "Do you wish to approve this corporate?",
            icon: are_you_sure_icon, closeOnClickOutside: false,
            buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
          })
            .then((value) => {
              switch (value) {
                case "action":
                  this.sendToBackend("APPROVE");
                  break;
                default:
              }
            });
  };
  rejectHandler = () => {
    swal({
      title: "Do you wish to reject this corporate?",
      icon: are_you_sure_icon, closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend("REJECT");
            break;
          default:
        }
      });
  };
  sendToBackend = (status) => {
    let {start_date, end_date, allowExternalReception, isStatus, park_service, visitor_service} = this.state;
    let service_array = [];

    if (park_service) {
      service_array.push(1)
    }

    if (visitor_service) {
      service_array.push(2)
    }
    const obj = {
      corporateCode: common.random5DigitNumGenarator(),
      services: service_array,
      contractStart: new Date(start_date).getTime(),
      contractEnd: new Date(end_date).getTime(),
      status: isStatus ? 1 : 0,
      allowExternalReception: allowExternalReception,
      temporaryCorporateId: this.props.data.temporaryCorporateId,
      action: status
    };

    const headers = {"Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)};
    this.props.spinnerHandler(true);
    axiosTags.patch(apiConfig.TEMP_CORPORATE_APPROVE_OR_REJECT, obj, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitHandler(status);
          return;
        }
        this.props.spinnerHandler(false);
      })
      .finally(fin => {
      });
  };

  render() {
    let data = this.props.data;
    return (

      <div className={""}>
        {data &&
        <MDBModal isOpen={true} toggle={() => {
        }} size="xl">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>{`Temporary Corporate Details #${data.temporaryCorporateId}`}</MDBModalHeader>
          <MDBModalBody>
            <Row className={"corp-reg-update "}>
              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    Corporate Details
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody className={"view-only-details"}>

                      {/*corporate details*/}
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Corporate BRC"}
                                  value={data.brc}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Corporate Name"}
                                  value={data.corporateName}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Corporate Email"}
                                  value={data.email}
                          />
                        </Form.Group>
                      </Form>
                      <br/>
                      {/*address*/}
                      <Form className={"_"}>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Address Line 1"}
                                  value={data.addressLine1}
                          />

                          <TxtLbl disable
                                  tagText={"Address Line 2"}
                                  value={data.addressLine2 === "" ? "-" : data.addressLine2}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"City/Town"}
                                  value={data.city}
                          />
                          <TxtLbl disable
                                  tagText={"Zip Code"}
                                  value={data.postalCode === "" ? "-" : data.postalCode}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"District"}
                                  value={data.district}
                          />
                          <TxtLbl disable
                                  tagText={"Province/State"}
                                  value={data.state}
                          />
                        </Form.Group>
                      </Form>

                      {/*corporate web/email/tel*/}
                      <Form className={"row_gap"}>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Web Address"}
                                  value={data.webAddress === "" ? "-" : data.webAddress}
                          />
                          <TxtLbl disable
                                  tagText={"Telephone"}
                                  value={data.contactNo === "" ? "-" : data.contactNo}
                          />
                        </Form.Group>
                      </Form>

                    </CardBody>
                  </Collapse>
                </Card>
              </Col>

              {/*corporate admin details*/}

              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    Corporate Administrator Details
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody className={"view-only-details"}>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Email / Username"}
                                  value={data.adminEmail}
                          />
                        </Form.Group>
                      </Form>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Full Name"}
                                  value={data.fullName}
                          />
                        </Form.Group>
                      </Form>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl disable
                                  tagText={"Mobile"}
                                  value={data.adminMobile}
                          />
                        </Form.Group>
                      </Form>

                    </CardBody>
                  </Collapse>
                </Card>

                {this.props.data.photoPath && this.props.data.photoPath !== "" ?
                <CardBody>
                  <Row>
                    <Col lg={12} className={"text-align-path col_gap"}>
                      <img src={this.props.data.photoPath} alt={"."} className={"cor-temp-img"}/>
                    </Col>
                  </Row>
                </CardBody>:null}

              </Col>
              <Col xs="12" className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    For the admin purpose
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody>
                      <Row>
                        {/*<Col lg={3}>*/}
                          {/*<Form>*/}
                            {/*<Form.Group widths='equal'>*/}
                              {/*<TxtLbl*/}
                                {/*required*/}
                                {/*tagText={"Corporate Code"}*/}
                                {/*placeholder={"Corporate Code"}*/}
                                {/*value={this.state.corporateCode}*/}
                                {/*onChange={this.handleChange('corporateCode')}*/}
                              {/*/>*/}
                            {/*</Form.Group>*/}
                          {/*</Form>*/}
                        {/*</Col>*/}
                        <Col lg={6}>
                          <Lbl required>Contract date range</Lbl>
                          <RangePicker
                            size={"mini"}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD"
                            onChange={this.onChange}
                          />
                        </Col>
                        <Col lg={6}>
                          <Form.Group widths='equal'>
                            <Lbl required>Allow external receptionist login</Lbl>
                            <Row>
                              <Col>
                                <Segment compact className={"segment-style"}>
                                  <Checkbox label={this.state.allowExternalReception ? 'Allow' : 'Not Allow'}
                                            className={"checkbox-style"} toggle
                                            checked={this.state.allowExternalReception}
                                            onChange={() => this.setState({allowExternalReception: !this.state.allowExternalReception})}/>
                                </Segment>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                        {/*<Col lg={3} className={"text-align-path"}>*/}
                          {/*<Lbl required>Status</Lbl>*/}
                          {/*<Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}*/}
                                    {/*checked={this.state.isStatus}*/}
                                    {/*onChange={() => this.setState({isStatus: !this.state.isStatus})} toggle*/}
                                    {/*label={this.state.isStatus ? 'Active' : 'Inactive'}/>*/}
                        {/*</Col>*/}

                        <Col xs={12} className={"mt-10"}/>

                        <Col lg={6}>
                          <Form.Group widths='equal'>
                            <Lbl required>Join service</Lbl>
                            <Row>
                              <Col>
                                <Segment compact className={"segment-style"}>
                                  <Checkbox label="Visitor" className={"checkbox-style"}
                                            checked={this.state.visitor_service}
                                            onChange={() => this.setState({visitor_service: !this.state.visitor_service})}/>
                                </Segment>
                              </Col>
                              <Col>
                                <Segment compact className={"segment-style"}>
                                  <Checkbox label="Park" className={"checkbox-style"}
                                            checked={this.state.park_service}
                                            onChange={() => this.setState({park_service: !this.state.park_service})}/>
                                </Segment>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>
              </Col>

              <Col lg={12} className={"mt-10 align-center"}>
                {data.temporaryCorporateStatus === "PENDING"|| data.temporaryCorporateStatus === "REJECTED" ?
                <SementicBtn className={"more-update"}
                             onClick={this.approveHandler}> Approve </SementicBtn>: null }
                {data.temporaryCorporateStatus === "PENDING"|| data.temporaryCorporateStatus === "APPROVED" ?
                <SementicBtn icon='trash alternate' className={"more-remove"}
                             onClick={this.rejectHandler}> Reject </SementicBtn>: null }

              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>

        }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data))
  };
};

export default connect(null, mapDispatchToProps)(App);
